import React from 'react';
import { connect, useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { Box, Divider, HorizontalScroll, TextLink, Typography } from '@drone-js/core';
import ReviewCardMinimal from 'component/page/detail/Review/ReviewCard/ReviewCardMinimal';
import queryActivitiesGqlApi from 'store/api/activitiesGqlApi';
import { ActivityGqlOperation, OperationKey } from 'store/api/api.types';
import { DefaultRequestProps } from 'store/api/ApiConstants';
import { mapReviewCardProps, ReviewCardProps } from 'component/page/detail/Review/Review.selectors';
import { mapDispatchToRecentReviewsProps, mapStateToProps, RecentReviewsProps } from 'component/page/detail/Review/RecentReviewsSection/RecentReviewSection.selectors';

const RecentReviewsSection: React.FC<RecentReviewsProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const [isLoading, setIsLoading] = React.useState(true);
    const [recentReviewsList, setRecentReviews] = React.useState<ReviewCardProps[]>([]);

    React.useEffect(() => {
        const reviewDefaultProps = {
            ...DefaultRequestProps.review,
            activityId: props.activityId,
        };
        queryActivitiesGqlApi({
            args: { props: reviewDefaultProps, customStateHandling: true },
            operation: ActivityGqlOperation.review,
            key: OperationKey.RecentReviews,
            onSuccess: (_operation, _args, response) => {
                setIsLoading(false);
                const list = mapReviewCardProps(response?.result?.reviews || [], cms);
                setRecentReviews(list);
            },
            onError: () => {
                setIsLoading(false);
            },
        });
    }, [props.activityId, cms]);

    if (recentReviewsList.length === 0 && !isLoading) {
        return null;
    }

    return (
        <>
            {recentReviewsList.length > 0 && (
                <>
                    <Divider direction="horizontal" my="4" mb="12" />
                    <Box display="flex" justifyContent="space-between">
                        <Typography variant="body-s-strong" tag="h3" mb="4">
                            {cms[326524]}
                        </Typography>
                        <TextLink
                            data-element-name="activities-view-all-reviews"
                            hierarchy="primary"
                            label={cms[326523]}
                            textVariant="body-s-strong"
                            onClick={() => props.onAllReviewClick(props.reviewSectionHref)}
                        />
                    </Box>
                    <HorizontalScroll display="flex" mb="12" mt="12" nextLabel={cms[130706]} previousLabel={cms[130765]} data-testid="activities-recent-reviews">
                        {recentReviewsList.map((review, index) => (
                            <Box me="12" key={index}>
                                <ReviewCardMinimal index={index} review={review} recentReview={true} />
                            </Box>
                        ))}
                    </HorizontalScroll>
                </>
            )}
        </>
    );
};
RecentReviewsSection.displayName = 'RecentReviewsSection';
export default connect(mapStateToProps, mapDispatchToRecentReviewsProps)(RecentReviewsSection);
